import { jsx as _jsx } from "react/jsx-runtime";
var MenuOutline = function MenuOutline(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.94824 6H20.0512C20.5732 6 21.0002 6.427 21.0002 6.949V7.051C21.0002 7.573 20.5732 8 20.0512 8H3.94824C3.42624 8 3.00024 7.573 3.00024 7.051V6.949C3.00024 6.427 3.42624 6 3.94824 6ZM20.0512 11H3.94824C3.42624 11 3.00024 11.427 3.00024 11.949V12.051C3.00024 12.573 3.42624 13 3.94824 13H20.0512C20.5732 13 21.0002 12.573 21.0002 12.051V11.949C21.0002 11.427 20.5732 11 20.0512 11ZM20.0512 16H3.94824C3.42624 16 3.00024 16.427 3.00024 16.949V17.051C3.00024 17.573 3.42624 18 3.94824 18H20.0512C20.5732 18 21.0002 17.573 21.0002 17.051V16.949C21.0002 16.427 20.5732 16 20.0512 16Z",
      fill: color
    })
  });
};
export default MenuOutline;